const Imageservice = () => {
  let list = [
    "5eccd87b5c93b2e7751ee229",
    "5ece306801f347edab70db7c",
    "5ece317501f347edab70db7d",
    "5ece326801f347edab70db7e",
    "5ed5c549458ca9ec427b1a00",
    "5ed7a2cf72f4e5e57a748789",
    "5ed7a3c172f4e5e57a74878d",
    "5ed7a27f72f4e5e57a748788",
    "5ed7a32b72f4e5e57a74878a",
    "5ed7a39d72f4e5e57a74878c",
    "5ed7a34272f4e5e57a74878b",
    "5ed7a40472f4e5e57a74878e",
    "5ed7a42672f4e5e57a74878f",
    "5ed7a45372f4e5e57a748790",
    "5ed7b0da72f4e5e57a748791",
    "5ed7b0fd72f4e5e57a748792",
    "5ed7b1b372f4e5e57a748797",
    "5ed7b13c72f4e5e57a748794",
    "5ed7b11672f4e5e57a748793",
    "5ed7b16172f4e5e57a748795",
    "5ed7b19072f4e5e57a748796",
    "5ed73bcfb2f15c60f8d7007d",
    "5ed79abaa419334baf732d42",
    "5ed79b2f72f4e5e57a74877f",
    "5ed79b8f72f4e5e57a748781",
    "5ed79b6272f4e5e57a748780",
    "5ed79bcb72f4e5e57a748782",
    "5ed79bdb72f4e5e57a748783",
    "5ed79bf472f4e5e57a748784",
    "5ed79c1872f4e5e57a748785",
    "5ed79c4172f4e5e57a748786",
    "5ed79ca772f4e5e57a748787",
    "5ed7398d31d6be3b4dcffa3c",
    "5ed7380431d6be3b4dcffa39",
    "5efb01c68661d7beabf03e9e",
    "5efb017a8661d7beabf03e9d",
    "5efb022d8661d7beabf03e9f",
    "5efb01368661d7beabf03e9c",
    "5f0ec7998bb9357e8ec94ae3",
    "5ed79938a419334baf732d41",
  ];
  return list;
};

export default Imageservice;
